import type { GameServer } from "@/api";
import { SERVER_HOURLY_COST } from "@/config";

export function runningServerSummary(
  servers: readonly GameServer[],
  balance: number,
): { count: number; hourlyCost: number; hoursRemaining: number | null } {
  let count = 0;
  let hourlyCost = 0;
  for (const server of servers) {
    if (server.status === "running") {
      count++;
      hourlyCost += server.hourlyCost ?? SERVER_HOURLY_COST;
    }
  }
  return {
    count,
    hourlyCost,
    hoursRemaining: hourlyCost > 0 ? Math.floor(balance / hourlyCost) : null,
  };
}
